import { NavLink } from 'react-router-dom'
import { AppBar, Box, Button, Container, Toolbar, Typography, Hidden, styled } from '@mui/material'
import { HelpOutline as FaqIcon } from '@mui/icons-material'
import DEFAULT from '../../config/default'

const FaqButton = () => {
    if (DEFAULT.api.countryCode !== 'AR') {
        return null
    }
    return (
        <FaqButtonStyled component={NavLink} to="/faqs" color="primary" startIcon={<FaqIcon />}>
            <FaqButtonTextStyled>Preguntas frecuentes</FaqButtonTextStyled>
        </FaqButtonStyled>
    )
}

const HeaderIndex = () => {
    return (
        <RootStyled>
            <Container>
                <Toolbar disableGutters>
                    <Hidden mdDown>
                        <Box sx={{ flexGrow: 1 }} />
                        { DEFAULT.api.countryCode !== 'AR' && (
                            <NameMdUpWrapperStyled>
                                <Typography color="primary" variant="caption" lineHeight="1.2" textTransform="uppercase">Webtracking</Typography>
                                <Typography variant="caption" lineHeight="1.2" textTransform="uppercase">Seguimiento de pedidos</Typography>
                            </NameMdUpWrapperStyled>
                        )}
                        <FaqButton />
                    </Hidden>
                    <Hidden mdUp>
                        { DEFAULT.api.countryCode !== 'AR' && (
                            <Typography color="primary" variant="caption" lineHeight="1.2" textTransform="uppercase">Webtracking</Typography>
                        )}
                        <Box sx={{ flexGrow: 1 }} />
                        { DEFAULT.api.countryCode !== 'AR' && (
                            <Typography variant="caption" lineHeight="1.2" textTransform="uppercase">Seguimiento de pedidos</Typography>
                        )}
                        <FaqButton />
                    </Hidden>
                </Toolbar>
            </Container>
        </RootStyled>
    )
}

const RootStyled = styled(AppBar)(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    justifyContent: 'center',
    position: 'relative',
    '@media all': {
        minHeight: 78
    }
}))

const NameMdUpWrapperStyled = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    marginLeft: theme.spacing(3),
    textAlign: 'right'
}))

const FaqButtonStyled = styled(Button)(({ theme }) => ({
    marginLeft: theme.spacing(1),
    flexShrink: 0,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
        minWidth: 'auto',
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        '& .MuiButton-startIcon': {
            margin: 0
        }
    }
}))

const FaqButtonTextStyled = styled('span')(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        display: 'none'
    }
}))

export default HeaderIndex
